/** @jsx jsx */
import { jsx } from '@emotion/react';

const Index = ({ height = 16 }: { height?: number }): React.ReactElement => {
  return (
    <svg width="16" height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM14 8C14 10.1982 12.8178 12.1204 11.0546 13.1653C11.6444 11.7716 12 9.96888 12 8C12 6.03112 11.6444 4.22836 11.0546 2.83465C12.8178 3.87963 14 5.80176 14 8ZM4 8C4 6.03112 4.35563 4.22837 4.94542 2.83465C3.18216 3.87963 2 5.80176 2 8C2 10.1982 3.18216 12.1204 4.94542 13.1653C4.35563 11.7716 4 9.96888 4 8ZM8.2653 13.8444C8.12013 13.9672 8.03993 14 8 14C7.96007 14 7.87987 13.9672 7.7347 13.8444C7.4834 13.6318 7.21125 13.2641 6.96043 12.7624C6.3618 11.5652 6 9.8544 6 8C6 6.1456 6.3618 4.43483 6.96043 3.23757C7.21125 2.73593 7.4834 2.36821 7.7347 2.15562C7.87987 2.03282 7.96007 2 8 2C8.03993 2 8.12013 2.03282 8.2653 2.15562C8.5166 2.36821 8.78875 2.73593 9.03957 3.23757C9.6382 4.43483 10 6.1456 10 8C10 9.8544 9.6382 11.5652 9.03957 12.7624C8.78875 13.2641 8.5166 13.6318 8.2653 13.8444Z"
        fill="#868E98"
      />
    </svg>
  );
};

export default Index;
